import { Modal } from 'components/Modal';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import styles from './ModalConfirmTemplate.module.scss';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { Loader } from '@mantine/core';

export const ModalConfirmTemplate = ({
  setShowConfirmModal,
  isDeleting,
  handleDelete,
}: {
  setShowConfirmModal: (e: boolean) => void;
  isDeleting: boolean;
  handleDelete: () => void;
}) => {
  return (
    <Modal setOpen={setShowConfirmModal}>
      <div className={styles.root}>
        <Title
          className={styles.root_title}
          title='Ты уверен, что хочешь удалить шаблон?'
        />
        <p className={styles.root_text}>
          После удаления шаблона, он больше не будет доступен для использования
        </p>

        <div className={styles.btn}>
          <Button
            onClick={() => setShowConfirmModal(false)}
            theme='outline'
            disabled={isDeleting}
            className={styles.btn_cancel}
            size='L'>
            <IconCancel />
          </Button>
          <Button
            onClick={handleDelete}
            disabled={isDeleting}
            className={styles.btn_exit}
            theme='filed'
            size='L'>
            <div>
              {isDeleting ? 'Удаление...' : 'Удалить'}
              {isDeleting ? <Loader size='xs' color='white' /> : <IconDone />}
            </div>
          </Button>
        </div>
      </div>
    </Modal>
  );
};
